const SectionTitle = ({ title, className }) => (
  <h2
    className={`text-[28px] md:text-[3rem] md:font-semibold md:mb-[20px] text-primary text-left ${className}`}
  >
    {title}
  </h2>
);

export default SectionTitle;
